import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-full-1 bg-grey-50" }
const _hoisted_2 = { class: "s20 widget bg-gradient-dark px-6 pt-8 pb-1" }
const _hoisted_3 = { class: "s20 items-center gap-6 pb-6 collapse-content-flex active" }
const _hoisted_4 = { class: "s3_mobile px-4" }
const _hoisted_5 = { class: "rounded-100 overflow-hidden item active" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "mt-5 text-center" }
const _hoisted_8 = { class: "s4_mobile" }
const _hoisted_9 = { class: "font-normal mt-2 mb-5" }
const _hoisted_10 = { class: "font-semibold my-2" }
const _hoisted_11 = { class: "font-semibold my-2" }
const _hoisted_12 = {
  key: 0,
  class: "font-normal mb-4"
}
const _hoisted_13 = {
  key: 1,
  class: "font-normal mb-4"
}
const _hoisted_14 = {
  key: 2,
  class: "tag-state warning stroke"
}
const _hoisted_15 = {
  key: 3,
  class: "tag-state success stroke"
}
const _hoisted_16 = {
  key: 4,
  class: "tag-state notif stroke"
}
const _hoisted_17 = {
  key: 5,
  class: "tag-state danger stroke"
}
const _hoisted_18 = {
  key: 6,
  class: "flex gap-2 text-grey-200 my-3"
}
const _hoisted_19 = { class: "s4_mobile px-6" }
const _hoisted_20 = {
  key: 0,
  class: "font-normal mb-4"
}
const _hoisted_21 = { class: "text-xl" }
const _hoisted_22 = {
  key: 1,
  class: "font-normal mb-4"
}
const _hoisted_23 = {
  key: 2,
  class: "font-normal mb-4"
}
const _hoisted_24 = { class: "text-xl" }
const _hoisted_25 = {
  key: 3,
  class: "font-normal mb-4"
}
const _hoisted_26 = { class: "font-normal mb-4" }
const _hoisted_27 = { class: "text-xl" }
const _hoisted_28 = {
  key: 4,
  class: "font-normal mb-4"
}
const _hoisted_29 = { class: "text-xl" }
const _hoisted_30 = {
  key: 5,
  class: "font-normal mb-4"
}
const _hoisted_31 = {
  key: 6,
  class: "font-normal mb-4"
}
const _hoisted_32 = { class: "text-xl" }
const _hoisted_33 = {
  key: 7,
  class: "font-normal mb-4"
}
const _hoisted_34 = { class: "s9_mobile" }
const _hoisted_35 = { class: "grid2" }
const _hoisted_36 = {
  class: "widget shadow-200 flex align-items-center rounded-30 px-7 py-5",
  style: {"background-color":"rgba(var(--color-black-rgb), 0.5)"}
}
const _hoisted_37 = { class: "s14" }
const _hoisted_38 = { class: "secondary-font font-bold text-primary-color" }
const _hoisted_39 = {
  class: "widget shadow-200 flex align-items-center rounded-30 px-7 py-5",
  style: {"background-color":"rgba(var(--color-black-rgb), 0.5)"}
}
const _hoisted_40 = { class: "s6" }
const _hoisted_41 = { class: "secondary-font font-normal text-grey-100" }
const _hoisted_42 = { class: "s14" }
const _hoisted_43 = { class: "secondary-font font-bold text-primary-color" }
const _hoisted_44 = {
  class: "widget shadow-200 flex align-items-center rounded-30 px-7 py-5",
  style: {"background-color":"rgba(var(--color-black-rgb), 0.8)"}
}
const _hoisted_45 = { class: "s14" }
const _hoisted_46 = { class: "secondary-font font-bold text-primary-color" }
const _hoisted_47 = {
  class: "widget shadow-200 flex align-items-center rounded-30 px-7 py-5",
  style: {"background-color":"rgba(var(--color-black-rgb), 0.5)"}
}
const _hoisted_48 = { class: "s6" }
const _hoisted_49 = { class: "secondary-font font-normal text-grey-100" }
const _hoisted_50 = { class: "s14" }
const _hoisted_51 = { class: "secondary-font font-bold text-primary-color" }
const _hoisted_52 = {
  class: "h-60 rounded-100 position-relative",
  style: {"width":"100%","background-color":"rgba(var(--color-white-rgb), 0.1)"}
}
const _hoisted_53 = { class: "s20 widget px-6 pt-8 pb-2" }
const _hoisted_54 = { class: "s10 mt--5-5 flex-right gap-3" }
const _hoisted_55 = ["disabled"]
const _hoisted_56 = ["disabled"]
const _hoisted_57 = { class: "s20 items-center gap-6 px-5 pb-6 collapse-content-flex active" }
const _hoisted_58 = { class: "s7_mobile pt-5" }
const _hoisted_59 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_60 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_61 = {
  key: 1,
  class: "tag-state danger stroke"
}
const _hoisted_62 = {
  key: 2,
  class: "tag-state warning stroke"
}
const _hoisted_63 = { class: "s6 rounded-50 overflow-hidden item" }
const _hoisted_64 = ["src"]
const _hoisted_65 = { class: "s14 mt-5 px-5" }
const _hoisted_66 = {
  key: 0,
  class: "text-grey-900 mb-3"
}
const _hoisted_67 = {
  key: 1,
  class: "text-grey-900 mb-3"
}
const _hoisted_68 = {
  key: 2,
  class: "font-normal my-1 text-grey-800"
}
const _hoisted_69 = {
  key: 3,
  class: "font-normal my-1 text-grey-800"
}
const _hoisted_70 = {
  key: 4,
  class: "font-normal my-1 text-grey-800"
}
const _hoisted_71 = {
  key: 5,
  class: "font-normal my-1 text-grey-800"
}
const _hoisted_72 = { class: "text-grey-900 mt-4" }
const _hoisted_73 = { class: "s6_mobile px-6" }
const _hoisted_74 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_75 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_76 = {
  key: 1,
  class: "tag-state danger stroke"
}
const _hoisted_77 = {
  key: 2,
  class: "tag-state warning stroke"
}
const _hoisted_78 = {
  key: 0,
  class: "text-grey-900 my-2"
}
const _hoisted_79 = {
  key: 1,
  class: "text-grey-900 my-2"
}
const _hoisted_80 = {
  key: 2,
  class: "text-grey-900 my-2"
}
const _hoisted_81 = {
  key: 3,
  class: "font-normal mb-4 text-grey-800"
}
const _hoisted_82 = {
  key: 4,
  class: "font-normal mb-4 text-grey-800"
}
const _hoisted_83 = {
  key: 5,
  class: "flex gap-4"
}
const _hoisted_84 = ["src"]
const _hoisted_85 = ["src"]
const _hoisted_86 = {
  key: 6,
  class: "flex gap-4"
}
const _hoisted_87 = ["src"]
const _hoisted_88 = {
  key: 7,
  class: "flex gap-4"
}
const _hoisted_89 = { class: "s7_mobile px-6" }
const _hoisted_90 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_91 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_92 = {
  key: 1,
  class: "tag-state danger stroke"
}
const _hoisted_93 = {
  key: 2,
  class: "tag-state warning stroke"
}
const _hoisted_94 = ["href"]
const _hoisted_95 = { class: "font-normal mb-2 text-grey-800" }
const _hoisted_96 = { class: "text-grey-500" }
const _hoisted_97 = { class: "mb-5 text-grey-800" }
const _hoisted_98 = ["href"]
const _hoisted_99 = { class: "font-normal mb-2 text-grey-800" }
const _hoisted_100 = { class: "text-grey-500" }
const _hoisted_101 = { class: "mb-5 text-grey-800" }
const _hoisted_102 = ["href"]
const _hoisted_103 = { class: "font-normal mb-2 text-grey-800" }
const _hoisted_104 = { class: "text-grey-500" }
const _hoisted_105 = { class: "mb-5 text-grey-800" }
const _hoisted_106 = {
  key: 1,
  class: "text-grey-500"
}
const _hoisted_107 = { class: "s20 widget px-6 pt-8 pb-2" }
const _hoisted_108 = { class: "s20 items-center gap-6 px-5 pb-6 collapse-content-flex active" }
const _hoisted_109 = { class: "s7_mobile pt-5" }
const _hoisted_110 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_111 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_112 = {
  key: 1,
  class: "tag-state warning stroke"
}
const _hoisted_113 = {
  key: 0,
  class: "text-grey-900"
}
const _hoisted_114 = {
  key: 1,
  class: "text-grey-900"
}
const _hoisted_115 = {
  key: 2,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_116 = {
  key: 3,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_117 = {
  key: 4,
  class: "font-semibold my-2 text-grey-800"
}
const _hoisted_118 = {
  key: 5,
  class: "font-semibold my-2 text-grey-800"
}
const _hoisted_119 = {
  key: 6,
  class: "mb-2 text-grey-800"
}
const _hoisted_120 = {
  key: 7,
  class: "mb-2 text-grey-800"
}
const _hoisted_121 = {
  key: 8,
  class: "tag-state warning stroke"
}
const _hoisted_122 = {
  key: 9,
  class: "tag-state success stroke"
}
const _hoisted_123 = {
  key: 10,
  class: "tag-state notif stroke"
}
const _hoisted_124 = {
  key: 11,
  class: "tag-state danger stroke"
}
const _hoisted_125 = { class: "s7_mobile px-6" }
const _hoisted_126 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_127 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_128 = {
  key: 1,
  class: "tag-state warning stroke"
}
const _hoisted_129 = { class: "text-grey-900 my-2" }
const _hoisted_130 = {
  key: 0,
  class: "font-normal mb-4 text-grey-800"
}
const _hoisted_131 = {
  key: 1,
  class: "font-normal mb-4 text-grey-800"
}
const _hoisted_132 = {
  key: 2,
  class: "font-normal mb-4 text-grey-800"
}
const _hoisted_133 = {
  key: 3,
  class: "font-normal mb-4 text-grey-800"
}
const _hoisted_134 = { class: "s6_mobile px-6" }
const _hoisted_135 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_136 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_137 = {
  key: 1,
  class: "tag-state warning stroke"
}
const _hoisted_138 = { class: "text-grey-900 my-2" }
const _hoisted_139 = { class: "text-grey-900 my-2" }
const _hoisted_140 = {
  key: 0,
  class: "font-normal mb-4 text-grey-800"
}
const _hoisted_141 = {
  key: 1,
  class: "font-normal mb-4 text-grey-800"
}
const _hoisted_142 = {
  key: 2,
  class: "font-normal mb-4 text-grey-800"
}
const _hoisted_143 = {
  key: 3,
  class: "font-normal mb-4 text-grey-800"
}
const _hoisted_144 = {
  key: 4,
  class: "mb-2 text-grey-800"
}
const _hoisted_145 = {
  key: 5,
  class: "mb-2 text-grey-800"
}
const _hoisted_146 = { class: "s20 widget px-6 pt-8 pb-2" }
const _hoisted_147 = { class: "s10 mt--5-5 flex-right" }
const _hoisted_148 = { class: "s20 items-center gap-6 px-5 pb-6 collapse-content-flex active" }
const _hoisted_149 = { class: "s7_mobile pt-6" }
const _hoisted_150 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_151 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_152 = {
  key: 1,
  class: "tag-state warning stroke"
}
const _hoisted_153 = {
  key: 0,
  class: "text-grey-900"
}
const _hoisted_154 = {
  key: 1,
  class: "text-grey-900"
}
const _hoisted_155 = {
  key: 2,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_156 = {
  key: 3,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_157 = {
  key: 4,
  class: "mb-2 text-grey-800"
}
const _hoisted_158 = {
  key: 5,
  class: "mb-2 text-grey-800"
}
const _hoisted_159 = {
  key: 6,
  class: "tag-state warning stroke"
}
const _hoisted_160 = {
  key: 7,
  class: "tag-state success stroke"
}
const _hoisted_161 = {
  key: 8,
  class: "tag-state notif stroke"
}
const _hoisted_162 = {
  key: 9,
  class: "tag-state danger stroke"
}
const _hoisted_163 = { class: "s7_mobile px-6" }
const _hoisted_164 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_165 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_166 = {
  key: 1,
  class: "tag-state warning stroke"
}
const _hoisted_167 = {
  key: 0,
  class: "text-grey-900 my-2"
}
const _hoisted_168 = {
  key: 1,
  class: "text-grey-900 my-2"
}
const _hoisted_169 = { class: "text-grey-900 my-2" }
const _hoisted_170 = {
  key: 2,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_171 = {
  key: 3,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_172 = {
  key: 4,
  class: "text-grey-800"
}
const _hoisted_173 = {
  key: 5,
  class: "text-grey-800"
}
const _hoisted_174 = {
  key: 6,
  class: "mb-2 text-grey-800"
}
const _hoisted_175 = {
  key: 7,
  class: "mb-2 text-grey-800"
}
const _hoisted_176 = { class: "s6_mobile px-6" }
const _hoisted_177 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_178 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_179 = {
  key: 1,
  class: "tag-state warning stroke"
}
const _hoisted_180 = {
  key: 0,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_181 = {
  key: 1,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_182 = { class: "font-normal text-primary-color mb-4" }
const _hoisted_183 = {
  key: 0,
  class: "tag-state notif stroke"
}
const _hoisted_184 = {
  key: 1,
  class: "tag-state warning stroke"
}
const _hoisted_185 = {
  key: 2,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_186 = {
  key: 3,
  class: "font-normal my-2 text-grey-800"
}
const _hoisted_187 = { class: "s20 widget px-6 pt-8 pb-2" }
const _hoisted_188 = { class: "s20 items-center gap-6 pb-4 collapse-content active" }
const _hoisted_189 = {
  class: "h-60 rounded-100 position-relative",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_190 = { class: "widget-floating py-0 text-xl flex-right" }
const _hoisted_191 = { class: "font-medium" }
const _hoisted_192 = {
  key: 0,
  class: "text-center py-5 text-grey-500"
}
const _hoisted_193 = {
  key: 1,
  class: "text-center py-5 text-grey-500"
}
const _hoisted_194 = {
  key: 2,
  class: "px-1",
  style: {"display":"grid","grid-template-columns":"repeat(auto-fill, minmax(220px, 1fr))","gap":"1rem"}
}
const _hoisted_195 = { class: "s10" }
const _hoisted_196 = { class: "secondary-font font-semibold mb-1" }
const _hoisted_197 = {
  class: "secondary-font font-semibold text-grey-900 py-1",
  style: {"white-space":"nowrap"}
}
const _hoisted_198 = { class: "s10 text-right" }
const _hoisted_199 = {
  key: 0,
  class: "secondary-font font-semibold text-grey-600 pb-2"
}
const _hoisted_200 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_201 = {
  key: 2,
  class: "mb-4"
}
const _hoisted_202 = {
  key: 3,
  class: "secondary-font font-semibold text-grey-600 pt-1 mb-4"
}
const _hoisted_203 = ["disabled", "onClick"]
const _hoisted_204 = { class: "s20 widget px-6 pt-8 pb-2" }
const _hoisted_205 = { class: "s20 items-center gap-6 px-5 pb-4 collapse-content active" }
const _hoisted_206 = { class: "flex items-center gap-6" }
const _hoisted_207 = { class: "s7" }
const _hoisted_208 = { class: "secondary-font font-semibold text-grey-900 my-2" }
const _hoisted_209 = { class: "secondary-font font-semibold text-grey-700 mb-4" }
const _hoisted_210 = {
  class: "h-40 rounded-100 position-relative overflow-hidden",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_211 = { class: "s7" }
const _hoisted_212 = { class: "secondary-font font-semibold text-grey-900 my-2" }
const _hoisted_213 = { class: "secondary-font font-semibold text-grey-700 mb-4" }
const _hoisted_214 = {
  class: "h-40 rounded-100 position-relative overflow-hidden",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_215 = { class: "s6" }
const _hoisted_216 = { class: "secondary-font font-semibold text-grey-900 my-2" }
const _hoisted_217 = {
  key: 0,
  class: "text-center py-5 text-grey-500"
}
const _hoisted_218 = {
  key: 1,
  class: "text-center py-5 text-grey-500"
}
const _hoisted_219 = {
  key: 2,
  class: "px-1",
  style: {"display":"grid","grid-template-columns":"repeat(auto-fill, minmax(220px, 1fr))","gap":"1rem"}
}
const _hoisted_220 = { class: "s10" }
const _hoisted_221 = { class: "secondary-font font-semibold mb-1" }
const _hoisted_222 = {
  class: "secondary-font font-semibold text-grey-900 py-1",
  style: {"white-space":"nowrap"}
}
const _hoisted_223 = { class: "secondary-font font-semibold text-purple" }
const _hoisted_224 = { class: "s10 text-right" }
const _hoisted_225 = {
  key: 0,
  class: "secondary-font font-semibold text-primary-color pb-1"
}
const _hoisted_226 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_227 = {
  key: 2,
  class: "mb-4"
}
const _hoisted_228 = {
  key: 3,
  class: "secondary-font font-semibold text-grey-600 pt-1"
}
const _hoisted_229 = {
  key: 4,
  class: "secondary-font font-semibold text-grey-600 py-1"
}
const _hoisted_230 = { class: "s20 widget px-6 pt-8 pb-2" }
const _hoisted_231 = { class: "s20 gap-6 px-5 pb-8 collapse-content active" }
const _hoisted_232 = {
  key: 0,
  class: "text-center py-5 text-grey-500"
}
const _hoisted_233 = {
  key: 1,
  class: "flex items-center gap-6"
}
const _hoisted_234 = { class: "s7" }
const _hoisted_235 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_236 = { class: "secondary-font font-semibold text-grey-700 mb-4" }
const _hoisted_237 = {
  class: "h-40 rounded-100 position-relative overflow-hidden",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_238 = { class: "s7" }
const _hoisted_239 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_240 = { class: "secondary-font font-semibold text-grey-700 mb-4" }
const _hoisted_241 = {
  class: "h-40 rounded-100 position-relative overflow-hidden",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_242 = { class: "s6" }
const _hoisted_243 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_244 = { class: "secondary-font font-semibold text-grey-700 mb-4" }
const _hoisted_245 = {
  class: "h-40 rounded-100 position-relative overflow-hidden",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}

import { formatAmount, formatDate } from '@/utils';
    import { useRoute } from 'vue-router';
    import { inject, ref, computed, onMounted } from 'vue';
    import axios from 'axios';
    import moment from 'moment';

    interface PrelevementMensuel {
        id: number;
        souscription_id: number;
        mois: number;
        date_prevision: string | null;
        date_operation: string | null;
        montant: number;
        statut: 'pending' | 'done' | 'cancelled';
        countdown: string | null;
    }

    interface DecaissementMensuel {
        id: number;
        mois: number;
        date_prevision: string | null;
        date_operation: string | null;
        montant: number;
        percent: number;
        statut: 'pending' | 'done' | 'cancelled';
        countdown: string | null;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'UsersDetailsView',
  setup(__props) {

    const route = useRoute();
    const BACKEND_URL = inject('BACKEND_URL');
    const user: any = ref(route.meta.user || {});
    const loading = ref(false);
    const errorMessage = ref('');

    const prelevementsMensuels = ref<PrelevementMensuel[]>([]);
    const prelevementsStats = ref({ total_attendu: 0, total_effectue: 0, percent: 0 });
    const prelevementsLoading = ref(false);
    const validatingPrelevementId = ref<number | null>(null);

    const decaissementsMensuels = ref<DecaissementMensuel[]>([]);
    const decaissementsStats = ref({
        debloque: 0,
        debloque_percent: 0,
        bloque: 0,
        bloque_percent: 0,
        total: 0,
    });
    const decaissementsLoading = ref(false);

    const walletInfos = ref({
        solde: 0,
        solde_percent: 0,
        utilise: 0,
        utilise_percent: 0,
        dernier_decaissement: 0,
        dernier_decaissement_percent: 0,
        dernier_decaissement_date: null as string | null,
    });
    const walletLoading = ref(false);

    onMounted(async () => {
        // Recharger les données utilisateur pour s'assurer qu'elles sont à jour
        if (route.params.id) {
            try {
                const response = await axios.get(`/backoffice/users/get/${route.params.id}`);
                user.value = response.data;
            } catch (error: any) {
                console.error('Erreur lors du chargement de l\'utilisateur:', error);
            }
            await loadPrelevementsMensuels();
            await loadDecaissementsMensuels();
            await loadWalletInfos();
        }
    });

    async function loadWalletInfos() {
        if (!route.params.id) return;
        walletLoading.value = true;
        try {
            const response = await axios.get(`/backoffice/users/${route.params.id}/wallet_infos`);
            walletInfos.value = response.data || walletInfos.value;
        } catch (error: any) {
            console.error('Erreur chargement wallet infos:', error);
        } finally {
            walletLoading.value = false;
        }
    }

    async function loadDecaissementsMensuels() {
        if (!route.params.id) return;
        decaissementsLoading.value = true;
        try {
            const response = await axios.get(`/backoffice/users/${route.params.id}/decaissements_mensuels`);
            decaissementsMensuels.value = response.data.items || [];
            decaissementsStats.value = response.data.stats || {
                debloque: 0, debloque_percent: 0,
                bloque: 0, bloque_percent: 0,
                total: 0,
            };
        } catch (error: any) {
            console.error('Erreur chargement décaissements mensuels:', error);
        } finally {
            decaissementsLoading.value = false;
        }
    }

    async function loadPrelevementsMensuels() {
        if (!route.params.id) return;
        prelevementsLoading.value = true;
        try {
            const response = await axios.get(`/backoffice/users/${route.params.id}/prelevements_mensuels`);
            prelevementsMensuels.value = response.data.items || [];
            prelevementsStats.value = response.data.stats || { total_attendu: 0, total_effectue: 0, percent: 0 };
        } catch (error: any) {
            console.error('Erreur chargement prélèvements mensuels:', error);
        } finally {
            prelevementsLoading.value = false;
        }
    }

    async function validatePrelevementMensuel(detail: PrelevementMensuel) {
        if (validatingPrelevementId.value !== null) return;
        validatingPrelevementId.value = detail.id;
        try {
            await axios.post(`/backoffice/users/${route.params.id}/prelevements_mensuels/${detail.id}/validate`);
            await loadPrelevementsMensuels();
        } catch (error: any) {
            const msg = error.response?.data?.message || 'Erreur lors de la validation.';
            alert(msg);
        } finally {
            validatingPrelevementId.value = null;
        }
    }

    function formatPrelevementDate(dateString: string | null): string {
        if (!dateString) return '-';
        const monthsFr = ['Jan', 'Fév', 'Mars', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'];
        const date = moment(dateString);
        if (!date.isValid()) return '-';
        return `${date.format('DD')} ${monthsFr[date.month()]} ${date.year()}`;
    }

    function formatPrelevementDateLong(dateString: string | null): string {
        if (!dateString) return '-';
        const monthsFr = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
        const date = moment(dateString);
        if (!date.isValid()) return '-';
        return `${date.format('DD')} ${monthsFr[date.month()]} ${date.year()}`;
    }

    function formatDateFrench(dateString: string | null): string {
        if (!dateString) return '';
        try {
            const date = moment(dateString);
            if (!date.isValid()) return '';
            const monthsFr = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
            return `${date.date()} ${monthsFr[date.month()]} ${date.year()}`;
        } catch {
            return dateString;
        }
    }

    function calculateAnciennete(dateEngagement: string | null): string {
        if (!dateEngagement) return '-';
        try {
            const engagementDate = moment(dateEngagement);
            if (!engagementDate.isValid()) return '-';
            const now = moment();
            const years = now.diff(engagementDate, 'years');
            const months = now.diff(engagementDate, 'months') % 12;
            
            if (years > 0 && months > 0) {
                return `${years} an${years > 1 ? 's' : ''} ${months} mois`;
            } else if (years > 0) {
                return `${years} an${years > 1 ? 's' : ''}`;
            } else if (months > 0) {
                return `${months} mois`;
            } else {
                return '0 mois';
            }
        } catch {
            return '-';
        }
    }

    const hasCarteEnAttenteRetrait = computed(() => {
        const cartes = user.value?.cartes;
        if (!Array.isArray(cartes)) return false;
        return cartes.some((c: any) => c?.statut === 'delivery');
    });

    const kycActionLoading = ref(false);
    const kycStatut = computed(() => user.value?.kyc?.statut);

    async function reloadUser() {
        if (!route.params.id) return;
        try {
            const response = await axios.get(`/backoffice/users/get/${route.params.id}`);
            user.value = response.data;
        } catch (error: any) {
            console.error('Erreur rechargement user:', error);
        }
    }

    async function validateKyc() {
        if (!user.value?.kyc) {
            alert('Aucun KYC à valider pour ce membre.');
            return;
        }
        if (!confirm('Confirmer la validation du KYC de ce membre ?')) return;
        kycActionLoading.value = true;
        try {
            await axios.post(`/backoffice/kyc/members/${route.params.id}/validate`);
            await reloadUser();
        } catch (error: any) {
            alert(error.response?.data?.message || 'Erreur lors de la validation.');
        } finally {
            kycActionLoading.value = false;
        }
    }

    async function rejectKyc() {
        if (!user.value?.kyc) {
            alert('Aucun KYC à rejeter pour ce membre.');
            return;
        }
        if (!confirm('Confirmer le rejet du KYC de ce membre ?')) return;
        kycActionLoading.value = true;
        try {
            await axios.post(`/backoffice/kyc/members/${route.params.id}/reject`);
            await reloadUser();
        } catch (error: any) {
            alert(error.response?.data?.message || 'Erreur lors du rejet.');
        } finally {
            kycActionLoading.value = false;
        }
    }

    const quotiteUsedPercent = computed(() => {
        if (!user.value.quotite_cessible_montant || !user.value.salaire || user.value.salaire <= 0) return 0;
        // Si on a une utilisation, on peut la calculer, sinon 0
        // Pour l'instant, on retourne 0 car on n'a pas de données d'utilisation
        return 0;
    });

    async function doSendConfirmationEmail() {
        loading.value = true;
        errorMessage.value = '';
        try {
            await axios.post(`/backoffice/users/send_confirmation_email`, { users_ids: [user.value.id] });
        } catch (error: any) {
            errorMessage.value = error.response?.data?.message || 'Une erreur est survenue lors de l\'envoi de l\'email.';
        } finally {
            loading.value = false;
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[124] || (_cache[124] = _createStaticVNode("<div class=\"page-space-40\"></div><h4 class=\"s7 font-semibold px-3 pb-5\">Membre / détail <span class=\"text-sm text-grey-500\"></span></h4><div class=\"s13 flex-right gap-3 mt--2 mb-5 px-5\"><span class=\"btn shadow-200 white2\">Souscription</span><span class=\"btn shadow-200 white2\">Contrat</span><span class=\"btn shadow-200 light2 border-none\">Prélèvement</span><span class=\"btn shadow-200 light2 border-none\">Premier prélèvement</span><span class=\"btn shadow-200 light2 border-none\">Décaissement mensuel</span><span class=\"btn shadow-200 light2 border-none\">Wallet / Utilisation</span></div>", 3)),
    _createElementVNode("div", _hoisted_2, [
      _cache[33] || (_cache[33] = _createStaticVNode("<div class=\"s10 mt--4 ml--4 mb-5 collapse-open-flex active\"><span class=\"px-5 py-4 bg-color-black rounded-100 text-xl\"><img src=\"/icons/icon-panel-open.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-open\" alt=\"\"><img src=\"/icons/icon-panel-close.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-close\" alt=\"\"> Souscription </span></div><div class=\"s10 mt--5-5 flex-right\"><button class=\"btn-ultra color2\"><div class=\"btn-show\"><img src=\"/icons/icon-actif.svg\" class=\"btn-icon\" alt=\"\"><span>Actif</span></div><div class=\"btn-loading\"><div class=\"loader-dots\"></div></div></button><button class=\"btn-ultra\"><div class=\"btn-show\"><img src=\"/icons/icon-valider.svg\" class=\"btn-icon icon-neutral\" alt=\"\"><span>Valider</span></div><div class=\"btn-loading\"><div class=\"loader-dots\"></div></div></button><button class=\"btn lg py-3 white2\"><img src=\"/icons/icon-consulter.svg\" class=\"btn-icon\" alt=\"\"><span>Utilisation</span></button></div><div class=\"clear-both h-10\"></div>", 3)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: !!user.value.photo_url ? user.value.photo_url : '/assets/users_avatar/600w/user.jpg',
              width: "100%"
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("h3", _hoisted_7, _toDisplayString(user.value.email || user.value.telephone || 'N/A'), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h3", null, _toDisplayString(user.value.nom + ' ' + user.value.prenom), 1),
          _createElementVNode("h4", _hoisted_9, _toDisplayString(user.value.collectivite?.nom || 'N/A'), 1),
          _createElementVNode("h6", _hoisted_10, _toDisplayString(user.value.telephone || 'N/A'), 1),
          _createElementVNode("h6", _hoisted_11, _toDisplayString(user.value.email || 'N/A'), 1),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
          (user.value.date_engagement)
            ? (_openBlock(), _createElementBlock("h6", _hoisted_12, [
                _cache[0] || (_cache[0] = _createTextVNode(" Date d'engagement ", -1)),
                _cache[1] || (_cache[1] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
                _createElementVNode("b", null, _toDisplayString(formatDateFrench(user.value.date_engagement)) + " - " + _toDisplayString(calculateAnciennete(user.value.date_engagement)), 1)
              ]))
            : (_openBlock(), _createElementBlock("h6", _hoisted_13, [...(_cache[2] || (_cache[2] = [
                _createTextVNode(" Date d'engagement ", -1),
                _createElementVNode("br", { class: "mb-2" }, null, -1),
                _createElementVNode("b", null, "-", -1)
              ]))])),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
          (!user.value.email_verified_at)
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, "En cours"))
            : _createCommentVNode("", true),
          (user.value.email_verified_at)
            ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Vérifié"))
            : _createCommentVNode("", true),
          (user.value.actif == 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Actif"))
            : _createCommentVNode("", true),
          (user.value.actif == 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Inactif"))
            : _createCommentVNode("", true),
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
          (user.value.last_connection_at)
            ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                _cache[3] || (_cache[3] = _createElementVNode("img", {
                  src: "/icons/icon-calendrier.svg",
                  class: "size-xs"
                }, null, -1)),
                _createTextVNode(" Dernière connexion: " + _toDisplayString(_unref(formatDate)(user.value.last_connection_at, 'DD/MM/YYYY')), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _cache[32] || (_cache[32] = _createElementVNode("div", null, [
          _createElementVNode("hr", { class: "hr-vertical hr-vertical-white h-100p" })
        ], -1)),
        _createElementVNode("div", _hoisted_19, [
          (user.value.created_at)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_20, [
                _cache[7] || (_cache[7] = _createTextVNode(" Date de souscription ", -1)),
                _cache[8] || (_cache[8] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
                _createElementVNode("b", _hoisted_21, _toDisplayString(formatDateFrench(user.value.created_at)), 1)
              ]))
            : (_openBlock(), _createElementBlock("h5", _hoisted_22, [...(_cache[9] || (_cache[9] = [
                _createTextVNode(" Date de souscription ", -1),
                _createElementVNode("br", { class: "mb-2" }, null, -1),
                _createElementVNode("b", { class: "text-xl" }, "-", -1)
              ]))])),
          (user.value.souscription?.date_fin)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_23, [
                _cache[10] || (_cache[10] = _createTextVNode(" Date de fin de souscription ", -1)),
                _cache[11] || (_cache[11] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
                _createElementVNode("b", _hoisted_24, _toDisplayString(formatDateFrench(user.value.souscription.date_fin)), 1)
              ]))
            : (_openBlock(), _createElementBlock("h5", _hoisted_25, [...(_cache[12] || (_cache[12] = [
                _createTextVNode(" Date de fin de souscription ", -1),
                _createElementVNode("br", { class: "mb-2" }, null, -1),
                _createElementVNode("b", { class: "text-xl" }, "-", -1)
              ]))])),
          _cache[21] || (_cache[21] = _createElementVNode("hr", { class: "hr-white" }, null, -1)),
          _createElementVNode("h5", _hoisted_26, [
            _cache[13] || (_cache[13] = _createTextVNode(" Utilisation total ", -1)),
            _cache[14] || (_cache[14] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
            _createElementVNode("b", _hoisted_27, _toDisplayString(user.value.balance ? _unref(formatAmount)(user.value.balance) + ' F' : '0 F'), 1)
          ]),
          (user.value.salaire)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_28, [
                _cache[15] || (_cache[15] = _createTextVNode(" Salaire Net après Utilisation ", -1)),
                _cache[16] || (_cache[16] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
                _createElementVNode("b", _hoisted_29, _toDisplayString(_unref(formatAmount)((user.value.salaire || 0) - (user.value.balance || 0))) + " F", 1)
              ]))
            : (_openBlock(), _createElementBlock("h5", _hoisted_30, [...(_cache[17] || (_cache[17] = [
                _createTextVNode(" Salaire Net après Utilisation ", -1),
                _createElementVNode("br", { class: "mb-2" }, null, -1),
                _createElementVNode("b", { class: "text-xl" }, "-", -1)
              ]))])),
          (user.value.quotite_cessible_pourcent && user.value.quotite_cessible_montant)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_31, [
                _cache[18] || (_cache[18] = _createTextVNode(" Quotité cessible disponible ", -1)),
                _cache[19] || (_cache[19] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
                _createElementVNode("b", _hoisted_32, _toDisplayString(user.value.quotite_cessible_pourcent) + "% - " + _toDisplayString(_unref(formatAmount)(user.value.quotite_cessible_montant)) + " F", 1)
              ]))
            : (_openBlock(), _createElementBlock("h5", _hoisted_33, [...(_cache[20] || (_cache[20] = [
                _createTextVNode(" Quotité cessible disponible ", -1),
                _createElementVNode("br", { class: "mb-2" }, null, -1),
                _createElementVNode("b", { class: "text-xl" }, "-", -1)
              ]))]))
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _cache[23] || (_cache[23] = _createElementVNode("div", { class: "s6" }, [
                _createElementVNode("h2", { class: "secondary-font font-normal text-grey-100" }, "Net"),
                _createElementVNode("h4", { class: "secondary-font font-normal text-grey-100" })
              ], -1)),
              _createElementVNode("div", _hoisted_37, [
                _cache[22] || (_cache[22] = _createElementVNode("h6", { class: "secondary-font font-medium text-grey-100 mb-1" }, "Salaire", -1)),
                _createElementVNode("h2", _hoisted_38, _toDisplayString(user.value.salaire ? _unref(formatAmount)(user.value.salaire) + ' F' : '-'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("h2", _hoisted_41, _toDisplayString(user.value.quotite_cessible_pourcent ? user.value.quotite_cessible_pourcent + '%' : '-'), 1),
                _cache[24] || (_cache[24] = _createElementVNode("h4", { class: "secondary-font font-normal text-grey-100" }, null, -1))
              ]),
              _createElementVNode("div", _hoisted_42, [
                _cache[25] || (_cache[25] = _createElementVNode("h6", { class: "secondary-font font-medium text-grey-100 mb-1" }, "Prélèvement sur salaire", -1)),
                _createElementVNode("h2", _hoisted_43, _toDisplayString(user.value.quotite_cessible_montant ? _unref(formatAmount)(user.value.quotite_cessible_montant) + ' F' : '-'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _cache[27] || (_cache[27] = _createElementVNode("div", { class: "s6" }, [
                _createElementVNode("h2", { class: "secondary-font font-normal text-grey-100" }, "Par"),
                _createElementVNode("h4", { class: "secondary-font font-normal text-grey-100" }, "mois")
              ], -1)),
              _createElementVNode("div", _hoisted_45, [
                _cache[26] || (_cache[26] = _createElementVNode("h6", { class: "secondary-font font-medium text-grey-100 mb-1" }, "Mon revolving", -1)),
                _createElementVNode("h2", _hoisted_46, _toDisplayString(user.value.balance ? _unref(formatAmount)(user.value.balance) + ' F' : '-'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("h2", _hoisted_49, _toDisplayString(user.value.souscription?.duree_mois || '-'), 1),
                _cache[28] || (_cache[28] = _createElementVNode("h4", { class: "secondary-font font-normal text-grey-100" }, "mois", -1))
              ]),
              _createElementVNode("div", _hoisted_50, [
                _cache[29] || (_cache[29] = _createElementVNode("h6", { class: "secondary-font font-medium text-grey-100 mb-1" }, "Pouvoir d'achat", -1)),
                _createElementVNode("h2", _hoisted_51, _toDisplayString(user.value.souscription?.montant ? _unref(formatAmount)(user.value.souscription.montant) + ' F' : '-'), 1)
              ])
            ])
          ]),
          _cache[31] || (_cache[31] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
          _createElementVNode("div", _hoisted_52, [
            _cache[30] || (_cache[30] = _createElementVNode("div", { class: "widget-floating py-0 text-xl flex-right" }, "Utilisation", -1)),
            _createElementVNode("div", {
              class: "h-100p flex align-items-center justify-content-left rounded-100 text-2xl px-5 bg-pop-green",
              style: _normalizeStyle(`width: ${quotiteUsedPercent.value}%;`)
            }, _toDisplayString(quotiteUsedPercent.value) + "% ", 5)
          ])
        ])
      ])
    ]),
    _cache[125] || (_cache[125] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _cache[126] || (_cache[126] = _createElementVNode("div", { class: "step vertical bg-grey-500 ml-auto mr-auto" }, null, -1)),
    _cache[127] || (_cache[127] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _createElementVNode("div", _hoisted_53, [
      _cache[54] || (_cache[54] = _createElementVNode("div", { class: "s10 mt--4 ml--4 mb-5 collapse-open-flex active" }, [
        _createElementVNode("span", { class: "px-5 py-4 bg-color-black rounded-100 text-xl" }, [
          _createElementVNode("img", {
            src: "/icons/icon-panel-open.svg",
            class: "size-xs icon-neutral mr-2 collapse-icon-open",
            alt: ""
          }),
          _createElementVNode("img", {
            src: "/icons/icon-panel-close.svg",
            class: "size-xs icon-neutral mr-2 collapse-icon-close",
            alt: ""
          }),
          _createTextVNode(" Identification / Bulettin ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_54, [
        _createVNode(_component_router_link, {
          to: `/app/users/${_unref(route).params.id}/kyc`,
          class: "btn-ultra",
          style: {"color":"var(--color-white) !important"}
        }, {
          default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
            _createElementVNode("div", { class: "btn-show" }, [
              _createElementVNode("img", {
                src: "/icons/icon-edit.svg",
                class: "btn-icon icon-white",
                alt: ""
              }),
              _createElementVNode("span", { style: {"color":"var(--color-white)"} }, "Editer")
            ], -1)
          ]))]),
          _: 1
        }, 8, ["to"]),
        _createElementVNode("button", {
          class: "btn-ultra danger",
          disabled: kycActionLoading.value || !user.value.kyc || kycStatut.value === 'rejected',
          onClick: rejectKyc
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["btn-show", { 'display-none': kycActionLoading.value }])
          }, [...(_cache[35] || (_cache[35] = [
            _createElementVNode("img", {
              src: "/icons/icon-denied.svg",
              class: "btn-icon icon-white",
              alt: ""
            }, null, -1),
            _createElementVNode("span", { style: {"color":"var(--color-white)"} }, "Rejeter", -1)
          ]))], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["btn-loading", { 'display-none': !kycActionLoading.value }])
          }, [...(_cache[36] || (_cache[36] = [
            _createElementVNode("div", { class: "loader-dots" }, null, -1)
          ]))], 2)
        ], 8, _hoisted_55),
        _createElementVNode("button", {
          class: "btn-ultra",
          disabled: kycActionLoading.value || !user.value.kyc || kycStatut.value === 'verified',
          onClick: validateKyc
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["btn-show", { 'display-none': kycActionLoading.value }])
          }, [...(_cache[37] || (_cache[37] = [
            _createElementVNode("img", {
              src: "/icons/icon-valider.svg",
              class: "btn-icon icon-neutral",
              alt: ""
            }, null, -1),
            _createElementVNode("span", null, "Valider", -1)
          ]))], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["btn-loading", { 'display-none': !kycActionLoading.value }])
          }, [...(_cache[38] || (_cache[38] = [
            _createElementVNode("div", { class: "loader-dots" }, null, -1)
          ]))], 2)
        ], 8, _hoisted_56)
      ]),
      _cache[55] || (_cache[55] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
      _createElementVNode("div", _hoisted_57, [
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("h3", _hoisted_59, [
            _cache[39] || (_cache[39] = _createTextVNode(" Identification   ", -1)),
            (user.value.kyc?.statut === 'verified')
              ? (_openBlock(), _createElementBlock("span", _hoisted_60, "Validé"))
              : (user.value.kyc?.statut === 'rejected')
                ? (_openBlock(), _createElementBlock("span", _hoisted_61, "Rejeté"))
                : (_openBlock(), _createElementBlock("span", _hoisted_62, "En attente"))
          ]),
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("img", {
              src: !!user.value.photo_url ? user.value.photo_url : '/assets/users_avatar/600w/user.jpg',
              width: "100%"
            }, null, 8, _hoisted_64)
          ]),
          _createElementVNode("div", _hoisted_65, [
            (user.value.kyc?.id)
              ? (_openBlock(), _createElementBlock("h4", _hoisted_66, "n° CF" + _toDisplayString(user.value.created_at ? _unref(moment)(user.value.created_at).format('YYYY') : '2025') + "-" + _toDisplayString(String(user.value.kyc.id).padStart(6, '0')), 1))
              : (_openBlock(), _createElementBlock("h4", _hoisted_67, "n° -")),
            (user.value.kyc?.created_at)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_68, "Effectuée le"))
              : _createCommentVNode("", true),
            (user.value.kyc?.created_at)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_69, _toDisplayString(_unref(formatDate)(user.value.kyc.created_at, 'DD/MM/YYYY HH:mm')), 1))
              : (user.value.created_at)
                ? (_openBlock(), _createElementBlock("h5", _hoisted_70, _toDisplayString(_unref(formatDate)(user.value.created_at, 'DD/MM/YYYY HH:mm')), 1))
                : (_openBlock(), _createElementBlock("h5", _hoisted_71, "-")),
            _createElementVNode("h5", _hoisted_72, _toDisplayString(user.value.nom + ' ' + user.value.prenom), 1)
          ])
        ]),
        _cache[52] || (_cache[52] = _createElementVNode("div", { class: "flex-center" }, [
          _createElementVNode("hr", { class: "hr-vertical h-100p" })
        ], -1)),
        _createElementVNode("div", _hoisted_73, [
          _createElementVNode("h3", _hoisted_74, [
            _cache[40] || (_cache[40] = _createTextVNode(" Pièce d'identité   ", -1)),
            (user.value.kyc?.statut === 'verified')
              ? (_openBlock(), _createElementBlock("span", _hoisted_75, "Validé"))
              : (user.value.kyc?.statut === 'rejected')
                ? (_openBlock(), _createElementBlock("span", _hoisted_76, "Rejeté"))
                : (_openBlock(), _createElementBlock("span", _hoisted_77, "En attente"))
          ]),
          (user.value.numero_piece_identite)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_78, " N° " + _toDisplayString(user.value.numero_piece_identite) + " / " + _toDisplayString(user.value.type_piece_identite || 'CNI'), 1))
            : (user.value.kyc?.piece_numero)
              ? (_openBlock(), _createElementBlock("h4", _hoisted_79, " N° " + _toDisplayString(user.value.kyc.piece_numero) + " / " + _toDisplayString(user.value.kyc?.piece_type || 'CNI'), 1))
              : (_openBlock(), _createElementBlock("h4", _hoisted_80, " N° - / - ")),
          (user.value.kyc?.piece_expiration)
            ? (_openBlock(), _createElementBlock("h6", _hoisted_81, [
                _cache[41] || (_cache[41] = _createTextVNode(" Date d'expiration ", -1)),
                _createElementVNode("b", null, _toDisplayString(formatDateFrench(user.value.kyc.piece_expiration)), 1)
              ]))
            : (_openBlock(), _createElementBlock("h6", _hoisted_82, [...(_cache[42] || (_cache[42] = [
                _createTextVNode(" Date d'expiration ", -1),
                _createElementVNode("b", null, "-", -1)
              ]))])),
          (user.value.document_identite_recto || user.value.document_identite_verso)
            ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                (user.value.document_identite_recto)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: user.value.document_identite_recto.fichier_url,
                      width: "100%"
                    }, null, 8, _hoisted_84))
                  : _createCommentVNode("", true),
                (user.value.document_identite_verso)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: user.value.document_identite_verso.fichier_url,
                      width: "100%"
                    }, null, 8, _hoisted_85))
                  : _createCommentVNode("", true)
              ]))
            : (user.value.kyc && user.value.kyc.kyc_documents && user.value.kyc.kyc_documents.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.value.kyc.kyc_documents.slice(0, 2), (doc, idx) => {
                    return (_openBlock(), _createElementBlock("img", {
                      key: idx,
                      src: doc.fichier_url,
                      width: "100%"
                    }, null, 8, _hoisted_87))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_88, [...(_cache[43] || (_cache[43] = [
                  _createElementVNode("div", { class: "text-grey-500" }, "Aucun document disponible", -1)
                ]))])),
          _cache[44] || (_cache[44] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1))
        ]),
        _cache[53] || (_cache[53] = _createElementVNode("div", { class: "flex-center" }, [
          _createElementVNode("hr", { class: "hr-vertical h-100p" })
        ], -1)),
        _createElementVNode("div", _hoisted_89, [
          _createElementVNode("h3", _hoisted_90, [
            _cache[45] || (_cache[45] = _createTextVNode(" Bulletins de salaires   ", -1)),
            (user.value.kyc?.statut === 'verified')
              ? (_openBlock(), _createElementBlock("span", _hoisted_91, "Validé"))
              : (user.value.kyc?.statut === 'rejected')
                ? (_openBlock(), _createElementBlock("span", _hoisted_92, "Rejeté"))
                : (_openBlock(), _createElementBlock("span", _hoisted_93, "En attente"))
          ]),
          (user.value.bulletin1_document || user.value.bulletin2_document || user.value.bulletin3_document)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (user.value.bulletin1_document)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: user.value.bulletin1_document.fichier_url,
                      target: "_blank"
                    }, [
                      _createElementVNode("h5", _hoisted_95, [
                        _cache[46] || (_cache[46] = _createTextVNode(" Bulletin 1 - ", -1)),
                        _createElementVNode("span", _hoisted_96, _toDisplayString(formatDateFrench(user.value.bulletin1_document.created_at)), 1)
                      ]),
                      _createElementVNode("h5", _hoisted_97, [
                        _cache[47] || (_cache[47] = _createElementVNode("img", {
                          src: "/icons/icon-download.svg",
                          class: "size-sm mr-2",
                          alt: ""
                        }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(user.value.bulletin1_document.fichier || 'fichier_bulletin.pdf'), 1)
                      ])
                    ], 8, _hoisted_94))
                  : _createCommentVNode("", true),
                (user.value.bulletin2_document)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: user.value.bulletin2_document.fichier_url,
                      target: "_blank"
                    }, [
                      _createElementVNode("h5", _hoisted_99, [
                        _cache[48] || (_cache[48] = _createTextVNode(" Bulletin 2 - ", -1)),
                        _createElementVNode("span", _hoisted_100, _toDisplayString(formatDateFrench(user.value.bulletin2_document.created_at)), 1)
                      ]),
                      _createElementVNode("h5", _hoisted_101, [
                        _cache[49] || (_cache[49] = _createElementVNode("img", {
                          src: "/icons/icon-download.svg",
                          class: "size-sm mr-2",
                          alt: ""
                        }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(user.value.bulletin2_document.fichier || 'fichier_bulletin.pdf'), 1)
                      ])
                    ], 8, _hoisted_98))
                  : _createCommentVNode("", true),
                (user.value.bulletin3_document)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 2,
                      href: user.value.bulletin3_document.fichier_url,
                      target: "_blank"
                    }, [
                      _createElementVNode("h5", _hoisted_103, [
                        _cache[50] || (_cache[50] = _createTextVNode(" Bulletin 3 - ", -1)),
                        _createElementVNode("span", _hoisted_104, _toDisplayString(formatDateFrench(user.value.bulletin3_document.created_at)), 1)
                      ]),
                      _createElementVNode("h5", _hoisted_105, [
                        _cache[51] || (_cache[51] = _createElementVNode("img", {
                          src: "/icons/icon-download.svg",
                          class: "size-sm mr-2",
                          alt: ""
                        }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(user.value.bulletin3_document.fichier || 'fichier_bulletin.pdf'), 1)
                      ])
                    ], 8, _hoisted_102))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createElementBlock("p", _hoisted_106, "Aucun bulletin disponible"))
        ])
      ])
    ]),
    _cache[128] || (_cache[128] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _cache[129] || (_cache[129] = _createElementVNode("div", { class: "step vertical bg-grey-500 ml-auto mr-auto" }, null, -1)),
    _cache[130] || (_cache[130] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _createElementVNode("div", _hoisted_107, [
      _cache[80] || (_cache[80] = _createStaticVNode("<div class=\"s10 mt--4 ml--4 mb-5 collapse-open-flex active\"><span class=\"px-5 py-4 bg-color-black rounded-100 text-xl\"><img src=\"/icons/icon-panel-open.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-open\" alt=\"\"><img src=\"/icons/icon-panel-close.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-close\" alt=\"\"> Contrat d&#39;engagement </span></div><div class=\"s10 mt--5-5 flex-right\"><button class=\"btn-ultra\"><div class=\"btn-show\"><img src=\"/icons/icon-valider.svg\" class=\"btn-icon icon-neutral\" alt=\"\"><span>Valider</span></div><div class=\"btn-loading\"><div class=\"loader-dots\"></div></div></button></div><div class=\"clear-both h-5\"></div>", 3)),
      _createElementVNode("div", _hoisted_108, [
        _createElementVNode("div", _hoisted_109, [
          _createElementVNode("h3", _hoisted_110, [
            _cache[56] || (_cache[56] = _createTextVNode(" Coop Finance   ", -1)),
            (user.value.souscription_id)
              ? (_openBlock(), _createElementBlock("span", _hoisted_111, "Validé"))
              : (_openBlock(), _createElementBlock("span", _hoisted_112, "En attente"))
          ]),
          (user.value.souscription_id)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_113, " Contrat n° / CF" + _toDisplayString(user.value.created_at ? _unref(moment)(user.value.created_at).format('YYYY') : '2025') + "-" + _toDisplayString(String(user.value.souscription_id).padStart(6, '0')), 1))
            : (_openBlock(), _createElementBlock("h4", _hoisted_114, "Contrat n° / -")),
          (user.value.souscription?.created_at)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_115, " Signé le " + _toDisplayString(formatDateFrench(user.value.souscription.created_at)), 1))
            : (_openBlock(), _createElementBlock("h5", _hoisted_116, "Signé le -")),
          (user.value.date_engagement)
            ? (_openBlock(), _createElementBlock("h6", _hoisted_117, " Durée: " + _toDisplayString(calculateAnciennete(user.value.date_engagement)), 1))
            : (_openBlock(), _createElementBlock("h6", _hoisted_118, "Durée: -")),
          _cache[57] || (_cache[57] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
          _cache[58] || (_cache[58] = _createElementVNode("h4", { class: "font-normal mb-2 text-grey-800" }, "Montant du contrat", -1)),
          (user.value.souscription?.montant)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_119, _toDisplayString(_unref(formatAmount)(user.value.souscription.montant)) + " F", 1))
            : (_openBlock(), _createElementBlock("h4", _hoisted_120, "-")),
          _cache[59] || (_cache[59] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
          (!user.value.email_verified_at)
            ? (_openBlock(), _createElementBlock("span", _hoisted_121, "En cours"))
            : _createCommentVNode("", true),
          (user.value.email_verified_at)
            ? (_openBlock(), _createElementBlock("span", _hoisted_122, "Vérifié"))
            : _createCommentVNode("", true),
          (user.value.actif == 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_123, "Actif"))
            : _createCommentVNode("", true),
          (user.value.actif == 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_124, "Inactif"))
            : _createCommentVNode("", true)
        ]),
        _cache[78] || (_cache[78] = _createElementVNode("div", { class: "flex-center" }, [
          _createElementVNode("hr", { class: "hr-vertical h-100p" })
        ], -1)),
        _createElementVNode("div", _hoisted_125, [
          _createElementVNode("h3", _hoisted_126, [
            _createTextVNode(_toDisplayString(user.value.collectivite?.nom || 'Collectivité') + "   ", 1),
            (user.value.collectivite_id)
              ? (_openBlock(), _createElementBlock("span", _hoisted_127, "Validé"))
              : (_openBlock(), _createElementBlock("span", _hoisted_128, "En attente"))
          ]),
          _createElementVNode("h4", _hoisted_129, "Identifiant / " + _toDisplayString(user.value.email || user.value.telephone || 'N/A'), 1),
          (user.value.date_engagement)
            ? (_openBlock(), _createElementBlock("h6", _hoisted_130, [
                _cache[60] || (_cache[60] = _createTextVNode(" Date de début de contrat ", -1)),
                _cache[61] || (_cache[61] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
                _createElementVNode("b", null, _toDisplayString(formatDateFrench(user.value.date_engagement)), 1)
              ]))
            : (_openBlock(), _createElementBlock("h6", _hoisted_131, [...(_cache[62] || (_cache[62] = [
                _createTextVNode(" Date de début de contrat ", -1),
                _createElementVNode("br", { class: "mb-2" }, null, -1),
                _createElementVNode("b", null, "-", -1)
              ]))])),
          (user.value.souscription?.date_fin)
            ? (_openBlock(), _createElementBlock("h6", _hoisted_132, [
                _cache[63] || (_cache[63] = _createTextVNode(" Date de fin de contrat ", -1)),
                _cache[64] || (_cache[64] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
                _createElementVNode("b", null, _toDisplayString(formatDateFrench(user.value.souscription.date_fin)), 1)
              ]))
            : (_openBlock(), _createElementBlock("h6", _hoisted_133, [...(_cache[65] || (_cache[65] = [
                _createTextVNode(" Date de fin de contrat ", -1),
                _createElementVNode("br", { class: "mb-2" }, null, -1),
                _createElementVNode("b", null, "-", -1)
              ]))])),
          _cache[66] || (_cache[66] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
          _cache[67] || (_cache[67] = _createElementVNode("h4", { class: "font-normal mb-2 text-grey-800" }, "Fond de la collectivité", -1)),
          _cache[68] || (_cache[68] = _createElementVNode("h4", { class: "mb-2 text-grey-800" }, "-", -1))
        ]),
        _cache[79] || (_cache[79] = _createElementVNode("div", { class: "flex-center" }, [
          _createElementVNode("hr", { class: "hr-vertical h-100p" })
        ], -1)),
        _createElementVNode("div", _hoisted_134, [
          _createElementVNode("h3", _hoisted_135, [
            _cache[69] || (_cache[69] = _createTextVNode(" Membre   ", -1)),
            (user.value.email_verified_at && user.value.actif == 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_136, "Validé"))
              : (_openBlock(), _createElementBlock("span", _hoisted_137, "En attente"))
          ]),
          _createElementVNode("h4", _hoisted_138, "Identifiant / " + _toDisplayString(user.value.email || user.value.telephone || 'N/A'), 1),
          _createElementVNode("h4", _hoisted_139, _toDisplayString(user.value.nom + ' ' + user.value.prenom), 1),
          (user.value.date_engagement)
            ? (_openBlock(), _createElementBlock("h6", _hoisted_140, [
                _cache[70] || (_cache[70] = _createTextVNode(" Date de début de contrat ", -1)),
                _cache[71] || (_cache[71] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
                _createElementVNode("b", null, _toDisplayString(formatDateFrench(user.value.date_engagement)), 1)
              ]))
            : (_openBlock(), _createElementBlock("h6", _hoisted_141, [...(_cache[72] || (_cache[72] = [
                _createTextVNode(" Date de début de contrat ", -1),
                _createElementVNode("br", { class: "mb-2" }, null, -1),
                _createElementVNode("b", null, "-", -1)
              ]))])),
          (user.value.souscription?.date_fin)
            ? (_openBlock(), _createElementBlock("h6", _hoisted_142, [
                _cache[73] || (_cache[73] = _createTextVNode(" Date de fin de contrat ", -1)),
                _cache[74] || (_cache[74] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
                _createElementVNode("b", null, _toDisplayString(formatDateFrench(user.value.souscription.date_fin)), 1)
              ]))
            : (_openBlock(), _createElementBlock("h6", _hoisted_143, [...(_cache[75] || (_cache[75] = [
                _createTextVNode(" Date de fin de contrat ", -1),
                _createElementVNode("br", { class: "mb-2" }, null, -1),
                _createElementVNode("b", null, "-", -1)
              ]))])),
          _cache[76] || (_cache[76] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
          _cache[77] || (_cache[77] = _createElementVNode("h4", { class: "font-normal mb-2 text-grey-800" }, "Prélèvement mensuel", -1)),
          (user.value.quotite_cessible_montant)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_144, _toDisplayString(_unref(formatAmount)(user.value.quotite_cessible_montant)) + " F", 1))
            : (_openBlock(), _createElementBlock("h4", _hoisted_145, "-"))
        ])
      ])
    ]),
    _cache[131] || (_cache[131] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _cache[132] || (_cache[132] = _createElementVNode("div", { class: "step vertical bg-grey-500 ml-auto mr-auto" }, null, -1)),
    _cache[133] || (_cache[133] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _createElementVNode("div", _hoisted_146, [
      _cache[98] || (_cache[98] = _createElementVNode("div", { class: "s10 mt--4 ml--4 mb-5 collapse-open-flex active" }, [
        _createElementVNode("span", { class: "px-5 py-4 bg-color-black rounded-100 text-xl" }, [
          _createElementVNode("img", {
            src: "/icons/icon-panel-open.svg",
            class: "size-xs icon-neutral mr-2 collapse-icon-open",
            alt: ""
          }),
          _createElementVNode("img", {
            src: "/icons/icon-panel-close.svg",
            class: "size-xs icon-neutral mr-2 collapse-icon-close",
            alt: ""
          }),
          _createTextVNode(" Premier prélèvement / Carte ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_147, [
        _createVNode(_component_router_link, {
          to: `/app/users/${_unref(route).params.id}/carte`,
          class: "btn lg py-3 white2 active"
        }, {
          default: _withCtx(() => [...(_cache[81] || (_cache[81] = [
            _createElementVNode("img", {
              src: "/icons/icon-consulter.svg",
              class: "btn-icon",
              alt: ""
            }, null, -1),
            _createElementVNode("span", null, "Carte", -1)
          ]))]),
          _: 1
        }, 8, ["to"])
      ]),
      _cache[99] || (_cache[99] = _createElementVNode("div", { class: "clear-both h-0" }, null, -1)),
      _createElementVNode("div", _hoisted_148, [
        _createElementVNode("div", _hoisted_149, [
          _createElementVNode("h3", _hoisted_150, [
            _cache[82] || (_cache[82] = _createTextVNode(" Premier prélèvement   ", -1)),
            (user.value.souscription_id)
              ? (_openBlock(), _createElementBlock("span", _hoisted_151, "Validé"))
              : (_openBlock(), _createElementBlock("span", _hoisted_152, "En attente"))
          ]),
          (user.value.souscription_id)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_153, " Signature / CF" + _toDisplayString(user.value.created_at ? _unref(moment)(user.value.created_at).format('YYYY') : '2025') + "-" + _toDisplayString(String(user.value.souscription_id).padStart(6, '0')), 1))
            : (_openBlock(), _createElementBlock("h4", _hoisted_154, "Signature / -")),
          (user.value.souscription?.created_at)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_155, " Effectué le " + _toDisplayString(_unref(formatDate)(user.value.souscription.created_at, 'DD/MM/YYYY HH:mm')), 1))
            : (_openBlock(), _createElementBlock("h5", _hoisted_156, "-")),
          _cache[83] || (_cache[83] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
          _cache[84] || (_cache[84] = _createElementVNode("h4", { class: "font-normal mb-2 text-grey-800" }, "Montant du prélèvement", -1)),
          (user.value.quotite_cessible_montant)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_157, _toDisplayString(_unref(formatAmount)(user.value.quotite_cessible_montant)) + " F", 1))
            : (_openBlock(), _createElementBlock("h4", _hoisted_158, "-")),
          _cache[85] || (_cache[85] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
          (!user.value.email_verified_at)
            ? (_openBlock(), _createElementBlock("span", _hoisted_159, "En cours"))
            : _createCommentVNode("", true),
          (user.value.email_verified_at)
            ? (_openBlock(), _createElementBlock("span", _hoisted_160, "Vérifié"))
            : _createCommentVNode("", true),
          (user.value.actif == 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_161, "Actif"))
            : _createCommentVNode("", true),
          (user.value.actif == 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_162, "Inactif"))
            : _createCommentVNode("", true)
        ]),
        _cache[96] || (_cache[96] = _createElementVNode("div", { class: "flex-center" }, [
          _createElementVNode("hr", { class: "hr-vertical h-100p" })
        ], -1)),
        _createElementVNode("div", _hoisted_163, [
          _createElementVNode("h3", _hoisted_164, [
            _cache[86] || (_cache[86] = _createTextVNode(" Création de la carte   ", -1)),
            (user.value.cartes && user.value.cartes.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_165, "Validé"))
              : (_openBlock(), _createElementBlock("span", _hoisted_166, "En attente"))
          ]),
          (user.value.cartes && user.value.cartes.length > 0)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_167, " **** **** **** " + _toDisplayString(user.value.cartes[0].bloc4 || (user.value.cartes[0].numero_masque ? user.value.cartes[0].numero_masque.slice(-4) : (user.value.cartes[0].numero ? user.value.cartes[0].numero.slice(-4) : '****'))), 1))
            : (_openBlock(), _createElementBlock("h4", _hoisted_168, "**** **** **** ****")),
          _createElementVNode("h4", _hoisted_169, _toDisplayString(user.value.collectivite?.nom || 'N/A'), 1),
          (user.value.cartes && user.value.cartes[0]?.created_at)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_170, " Créé le " + _toDisplayString(_unref(formatDate)(user.value.cartes[0].created_at, 'DD/MM/YYYY HH:mm')), 1))
            : (_openBlock(), _createElementBlock("h5", _hoisted_171, "-")),
          _cache[88] || (_cache[88] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
          (user.value.cartes && user.value.cartes[0]?.reference)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_172, "Référence / " + _toDisplayString(user.value.cartes[0].reference), 1))
            : (_openBlock(), _createElementBlock("h4", _hoisted_173, "Référence / -")),
          _cache[89] || (_cache[89] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
          _cache[90] || (_cache[90] = _createElementVNode("h4", { class: "font-normal mb-2 text-grey-800" }, "Montant disponible", -1)),
          (user.value.cartes && user.value.cartes[0])
            ? (_openBlock(), _createElementBlock("h4", _hoisted_174, _toDisplayString(_unref(formatAmount)(user.value.cartes[0].solde || 0)) + " F", 1))
            : (_openBlock(), _createElementBlock("h4", _hoisted_175, "-")),
          (hasCarteEnAttenteRetrait.value)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 8,
                to: `/app/users/${_unref(route).params.id}/carte`,
                class: "btn lg full danger mt-5",
                style: {"color":"var(--color-white) !important"}
              }, {
                default: _withCtx(() => [...(_cache[87] || (_cache[87] = [
                  _createElementVNode("img", {
                    src: "/icons/icon-valider.svg",
                    class: "btn-icon icon-white",
                    alt: ""
                  }, null, -1),
                  _createElementVNode("span", { style: {"color":"var(--color-white)"} }, "Retrait de carte", -1)
                ]))]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ]),
        _cache[97] || (_cache[97] = _createElementVNode("div", { class: "flex-center" }, [
          _createElementVNode("hr", { class: "hr-vertical h-100p" })
        ], -1)),
        _createElementVNode("div", _hoisted_176, [
          _createElementVNode("h3", _hoisted_177, [
            _cache[91] || (_cache[91] = _createTextVNode(" Livraison   ", -1)),
            (user.value.cartes && user.value.cartes[0]?.created_at)
              ? (_openBlock(), _createElementBlock("span", _hoisted_178, "Validé"))
              : (_openBlock(), _createElementBlock("span", _hoisted_179, "En attente"))
          ]),
          _cache[93] || (_cache[93] = _createElementVNode("h5", { class: "text-grey-900 my-2" }, "Point relais - collectivité", -1)),
          (user.value.cartes && user.value.cartes[0]?.created_at)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_180, " Livré le " + _toDisplayString(_unref(formatDate)(user.value.cartes[0].created_at, 'DD/MM/YYYY HH:mm')), 1))
            : (_openBlock(), _createElementBlock("h5", _hoisted_181, "-")),
          _cache[94] || (_cache[94] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
          _createElementVNode("h3", _hoisted_182, [
            _cache[92] || (_cache[92] = _createTextVNode(" Réception   ", -1)),
            (user.value.cartes && user.value.cartes[0]?.date_retrait)
              ? (_openBlock(), _createElementBlock("span", _hoisted_183, "Validé"))
              : (_openBlock(), _createElementBlock("span", _hoisted_184, "En attente"))
          ]),
          _cache[95] || (_cache[95] = _createElementVNode("h5", { class: "text-grey-900 my-2" }, "Point relais - collectivité", -1)),
          (user.value.cartes && user.value.cartes[0]?.date_retrait)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_185, " Reçu le " + _toDisplayString(_unref(formatDate)(user.value.cartes[0].date_retrait, 'DD/MM/YYYY HH:mm')), 1))
            : (_openBlock(), _createElementBlock("h5", _hoisted_186, "Carte non encore retirée"))
        ])
      ])
    ]),
    _cache[134] || (_cache[134] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _cache[135] || (_cache[135] = _createElementVNode("div", { class: "step vertical bg-grey-500 ml-auto mr-auto" }, null, -1)),
    _cache[136] || (_cache[136] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _createElementVNode("div", _hoisted_187, [
      _cache[107] || (_cache[107] = _createStaticVNode("<div class=\"s10 mt--4 ml--4 mb-5 collapse-open active\"><span class=\"px-5 py-4 bg-color-black rounded-100 text-xl\"><img src=\"/icons/icon-panel-open.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-open\" alt=\"\"><img src=\"/icons/icon-panel-close.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-close\" alt=\"\"> Prélèvement mensuel </span></div><div class=\"s10 mt--5-5 flex-right\"><button class=\"btn lg py-3 white2 active\"><img src=\"/icons/icon-consulter.svg\" class=\"btn-icon\" alt=\"\"><span>Plan mensuel</span></button></div>", 2)),
      _createElementVNode("div", _hoisted_188, [
        _cache[104] || (_cache[104] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
        _createElementVNode("div", _hoisted_189, [
          _createElementVNode("div", _hoisted_190, _toDisplayString(prelevementsStats.value.percent) + "%", 1),
          _createElementVNode("div", {
            class: "h-100p flex align-items-center rounded-100 px-7 bg-pop-green",
            style: _normalizeStyle(`width: ${Math.min(prelevementsStats.value.percent, 100)}%;`)
          }, [
            _createElementVNode("h2", null, _toDisplayString(_unref(formatAmount)(prelevementsStats.value.total_effectue)) + " F", 1),
            _createElementVNode("h2", _hoisted_191, "  / " + _toDisplayString(_unref(formatAmount)(prelevementsStats.value.total_attendu)) + " F", 1)
          ], 4)
        ]),
        _cache[105] || (_cache[105] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
        (prelevementsLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_192, " Chargement des prélèvements mensuels... "))
          : (prelevementsMensuels.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_193, " Aucun prélèvement mensuel disponible pour ce membre. "))
            : (_openBlock(), _createElementBlock("div", _hoisted_194, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prelevementsMensuels.value, (detail) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: detail.id,
                    class: _normalizeClass(["widget border border-3 shadow-200 rounded-30 gap-5 px-7 py-5", { active: detail.statut === 'done', 'opacity-6': detail.statut === 'cancelled' }])
                  }, [
                    _createElementVNode("div", _hoisted_195, [
                      _createElementVNode("h6", _hoisted_196, _toDisplayString(formatPrelevementDateLong(detail.date_prevision)), 1),
                      _createElementVNode("h3", _hoisted_197, _toDisplayString(_unref(formatAmount)(detail.montant)) + " F", 1)
                    ]),
                    _createElementVNode("div", _hoisted_198, [
                      (detail.statut === 'pending' && detail.countdown)
                        ? (_openBlock(), _createElementBlock("h5", _hoisted_199, _toDisplayString(detail.countdown), 1))
                        : _createCommentVNode("", true),
                      (detail.statut === 'done')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_200, [...(_cache[100] || (_cache[100] = [
                            _createElementVNode("span", { class: "tag-state notif stroke" }, "Effectué", -1)
                          ]))]))
                        : (detail.statut === 'cancelled')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_201, [...(_cache[101] || (_cache[101] = [
                              _createElementVNode("span", { class: "tag-state danger stroke" }, "Annulé", -1)
                            ]))]))
                          : _createCommentVNode("", true),
                      (detail.statut === 'done' && detail.date_operation)
                        ? (_openBlock(), _createElementBlock("h6", _hoisted_202, "Le " + _toDisplayString(formatPrelevementDate(detail.date_operation)), 1))
                        : _createCommentVNode("", true),
                      (detail.statut === 'pending')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 4,
                            class: "btn-ultra w-100 shadow-0",
                            disabled: validatingPrelevementId.value !== null,
                            onClick: ($event: any) => (validatePrelevementMensuel(detail))
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["btn-show", { 'display-none': validatingPrelevementId.value === detail.id }])
                            }, [...(_cache[102] || (_cache[102] = [
                              _createElementVNode("img", {
                                src: "/icons/icon-valider.svg",
                                class: "btn-icon",
                                alt: ""
                              }, null, -1),
                              _createElementVNode("span", null, "Valider", -1)
                            ]))], 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["btn-loading", { 'display-none': validatingPrelevementId.value !== detail.id }])
                            }, [...(_cache[103] || (_cache[103] = [
                              _createElementVNode("div", { class: "loader-dots" }, null, -1)
                            ]))], 2)
                          ], 8, _hoisted_203))
                        : _createCommentVNode("", true)
                    ])
                  ], 2))
                }), 128))
              ])),
        _cache[106] || (_cache[106] = _createElementVNode("div", { class: "clear-both h-15" }, null, -1))
      ])
    ]),
    _cache[137] || (_cache[137] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _cache[138] || (_cache[138] = _createElementVNode("div", { class: "step vertical bg-grey-500 ml-auto mr-auto" }, null, -1)),
    _cache[139] || (_cache[139] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _createElementVNode("div", _hoisted_204, [
      _cache[118] || (_cache[118] = _createStaticVNode("<div class=\"s10 mt--4 ml--4 mb-5 collapse-open active\"><span class=\"px-5 py-4 bg-color-black rounded-100 text-xl\"><img src=\"/icons/icon-panel-open.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-open\" alt=\"\"><img src=\"/icons/icon-panel-close.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-close\" alt=\"\"> Décaissement mensuel </span></div><div class=\"s10 mt--5-5 flex-right gap-4\"><button class=\"btn lg py-3 white2 active\"><img src=\"/icons/icon-consulter.svg\" class=\"btn-icon\" alt=\"\"><span>Revolving</span></button></div>", 2)),
      _createElementVNode("div", _hoisted_205, [
        _cache[115] || (_cache[115] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
        _createElementVNode("div", _hoisted_206, [
          _createElementVNode("div", _hoisted_207, [
            _cache[108] || (_cache[108] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
              _createElementVNode("div", { class: "circle-medium bg-color-1000" }),
              _createTextVNode(" Débloqué ")
            ], -1)),
            _createElementVNode("h1", _hoisted_208, _toDisplayString(_unref(formatAmount)(decaissementsStats.value.debloque)) + " F", 1),
            _createElementVNode("h5", _hoisted_209, _toDisplayString(decaissementsStats.value.debloque_percent) + "%", 1),
            _createElementVNode("div", _hoisted_210, [
              _createElementVNode("div", {
                class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-1000 text-white",
                style: _normalizeStyle(`width: ${decaissementsStats.value.debloque_percent}%;`)
              }, _toDisplayString(decaissementsStats.value.debloque_percent) + "% ", 5)
            ])
          ]),
          _createElementVNode("div", _hoisted_211, [
            _cache[109] || (_cache[109] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
              _createElementVNode("div", { class: "circle-medium bg-purple" }),
              _createTextVNode(" Bloqué ")
            ], -1)),
            _createElementVNode("h1", _hoisted_212, _toDisplayString(_unref(formatAmount)(decaissementsStats.value.bloque)) + " F", 1),
            _createElementVNode("h5", _hoisted_213, _toDisplayString(decaissementsStats.value.bloque_percent) + "%", 1),
            _createElementVNode("div", _hoisted_214, [
              _createElementVNode("div", {
                class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-purple text-white",
                style: _normalizeStyle(`width: ${decaissementsStats.value.bloque_percent}%;`)
              }, _toDisplayString(decaissementsStats.value.bloque_percent) + "% ", 5)
            ])
          ]),
          _createElementVNode("div", _hoisted_215, [
            _cache[110] || (_cache[110] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
              _createElementVNode("div", { class: "circle-medium bg-green-light" }),
              _createTextVNode(" Total ")
            ], -1)),
            _createElementVNode("h1", _hoisted_216, _toDisplayString(_unref(formatAmount)(decaissementsStats.value.total)) + " F", 1),
            _cache[111] || (_cache[111] = _createElementVNode("h5", { class: "secondary-font font-semibold text-grey-700 mb-4" }, "100%", -1)),
            _cache[112] || (_cache[112] = _createElementVNode("div", {
              class: "h-40 rounded-100 position-relative overflow-hidden",
              style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
            }, [
              _createElementVNode("div", {
                class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-green-light",
                style: {"width":"100%"}
              }, " 100% ")
            ], -1))
          ])
        ]),
        _cache[116] || (_cache[116] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
        (decaissementsLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_217, " Chargement des décaissements mensuels... "))
          : (decaissementsMensuels.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_218, " Aucun décaissement mensuel disponible pour ce membre. "))
            : (_openBlock(), _createElementBlock("div", _hoisted_219, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(decaissementsMensuels.value, (detail) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: detail.id,
                    class: _normalizeClass(["widget border border-3 shadow-200 rounded-30 gap-5 px-7 py-5", { active: detail.statut === 'done', 'opacity-6': detail.statut === 'cancelled' }])
                  }, [
                    _createElementVNode("div", _hoisted_220, [
                      _createElementVNode("h6", _hoisted_221, _toDisplayString(formatPrelevementDateLong(detail.date_prevision)), 1),
                      _createElementVNode("h3", _hoisted_222, _toDisplayString(_unref(formatAmount)(detail.montant)) + " F", 1),
                      _createElementVNode("p", _hoisted_223, _toDisplayString(detail.percent) + "%", 1)
                    ]),
                    _createElementVNode("div", _hoisted_224, [
                      (detail.statut === 'pending' && detail.countdown)
                        ? (_openBlock(), _createElementBlock("h5", _hoisted_225, _toDisplayString(detail.countdown), 1))
                        : _createCommentVNode("", true),
                      (detail.statut === 'done')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_226, [...(_cache[113] || (_cache[113] = [
                            _createElementVNode("span", { class: "tag-state notif stroke" }, "Effectué", -1)
                          ]))]))
                        : (detail.statut === 'cancelled')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_227, [...(_cache[114] || (_cache[114] = [
                              _createElementVNode("span", { class: "tag-state danger stroke" }, "Annulé", -1)
                            ]))]))
                          : _createCommentVNode("", true),
                      (detail.statut === 'done' && detail.date_operation)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_228, "Date de déblocage"))
                        : _createCommentVNode("", true),
                      (detail.statut === 'done' && detail.date_operation)
                        ? (_openBlock(), _createElementBlock("h6", _hoisted_229, _toDisplayString(formatPrelevementDate(detail.date_operation)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ], 2))
                }), 128))
              ])),
        _cache[117] || (_cache[117] = _createElementVNode("div", { class: "clear-both h-15" }, null, -1))
      ])
    ]),
    _cache[140] || (_cache[140] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _cache[141] || (_cache[141] = _createElementVNode("div", { class: "step vertical bg-grey-500 ml-auto mr-auto" }, null, -1)),
    _cache[142] || (_cache[142] = _createElementVNode("div", { class: "clear-both h-5" }, null, -1)),
    _createElementVNode("div", _hoisted_230, [
      _cache[123] || (_cache[123] = _createStaticVNode("<div class=\"s10 mt--4 ml--4 mb-5 collapse-open active\"><span class=\"px-5 py-4 bg-color-black rounded-100 text-xl\"><img src=\"/icons/icon-panel-open.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-open\" alt=\"\"><img src=\"/icons/icon-panel-close.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-close\" alt=\"\"> Wallet / Utilisation </span></div><div class=\"s10 mt--5-5 flex-right\"><button class=\"btn lg py-3 white2 active\"><img src=\"/icons/icon-consulter.svg\" class=\"btn-icon\" alt=\"\"><span>Utilisation</span></button></div>", 2)),
      _createElementVNode("div", _hoisted_231, [
        _cache[122] || (_cache[122] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
        (walletLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_232, " Chargement du wallet... "))
          : (_openBlock(), _createElementBlock("div", _hoisted_233, [
              _createElementVNode("div", _hoisted_234, [
                _cache[119] || (_cache[119] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
                  _createElementVNode("div", { class: "circle-medium bg-color-1000" }),
                  _createTextVNode(" Solde ")
                ], -1)),
                _createElementVNode("h1", _hoisted_235, _toDisplayString(_unref(formatAmount)(walletInfos.value.solde)) + " F", 1),
                _createElementVNode("h5", _hoisted_236, _toDisplayString(walletInfos.value.solde_percent) + "%", 1),
                _createElementVNode("div", _hoisted_237, [
                  _createElementVNode("div", {
                    class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-1000 text-white",
                    style: _normalizeStyle(`width: ${walletInfos.value.solde_percent}%;`)
                  }, _toDisplayString(walletInfos.value.solde_percent) + "% ", 5)
                ])
              ]),
              _createElementVNode("div", _hoisted_238, [
                _cache[120] || (_cache[120] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
                  _createElementVNode("div", { class: "circle-medium bg-purple" }),
                  _createTextVNode(" Montant Utilisé ")
                ], -1)),
                _createElementVNode("h1", _hoisted_239, _toDisplayString(_unref(formatAmount)(walletInfos.value.utilise)) + " F", 1),
                _createElementVNode("h5", _hoisted_240, _toDisplayString(walletInfos.value.utilise_percent) + "%", 1),
                _createElementVNode("div", _hoisted_241, [
                  _createElementVNode("div", {
                    class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-purple text-white",
                    style: _normalizeStyle(`width: ${walletInfos.value.utilise_percent}%;`)
                  }, _toDisplayString(walletInfos.value.utilise_percent) + "% ", 5)
                ])
              ]),
              _createElementVNode("div", _hoisted_242, [
                _cache[121] || (_cache[121] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
                  _createElementVNode("div", { class: "circle-medium bg-green-light" }),
                  _createTextVNode(" Dernier décaissement ")
                ], -1)),
                _createElementVNode("h1", _hoisted_243, _toDisplayString(_unref(formatAmount)(walletInfos.value.dernier_decaissement)) + " F", 1),
                _createElementVNode("h5", _hoisted_244, _toDisplayString(walletInfos.value.dernier_decaissement_percent) + "%", 1),
                _createElementVNode("div", _hoisted_245, [
                  _createElementVNode("div", {
                    class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-green-light",
                    style: _normalizeStyle(`width: ${walletInfos.value.dernier_decaissement_percent}%;`)
                  }, _toDisplayString(walletInfos.value.dernier_decaissement_percent) + "% ", 5)
                ])
              ])
            ]))
      ])
    ]),
    _cache[143] || (_cache[143] = _createElementVNode("div", { class: "clear-both h-80" }, null, -1))
  ]))
}
}

})